import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref } from "vue"
import { Step } from "../constants"
import InvitationLayout from "../shared/InvitationLayout.vue"
import { useMutation } from "@/hooks/useMutation"
import FinalStep from "../shared/FinalStep.vue"
import {
  AcceptInvitationMutation,
  AcceptInvitationMutationMutationVariables,
  AcceptInvitationMutationMutation,
} from "@/gql"
import useRouter from "@/router/useRouter"
import CheckStep from "../shared/CheckStep.vue"
import { AHEAD_THEME, ProductTypeEnum } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionUserInvitationFlow',
  props: {
    invitationId: null,
    email: null
  },
  setup(__props: any) {

const props = __props as { invitationId: string; email?: string }


const productType = inject("productType") as Ref<ProductTypeEnum>

const step = ref(Step.PersonalInfo)
const observer = ref(null)

const isEmailAvailable = computed(() => Boolean(props.email))
const gotoFinal = () => {
  step.value = Step.Final
}

const isSubmitting = ref(false)
const { router } = useRouter()

const form = ref({
  invitationId: props.invitationId,
  token: router.currentRoute.params?.token || "",
  newSubscriptionUserInput: {
    email: props.email || "",
    name: "",
  },
})

const { mutate } = useMutation()

const onSubmit = async () => {
  const validity = await (observer.value as any).validateWithInfo()

  if (!validity.isValid) return

  isSubmitting.value = true

  const result = await mutate<
    AcceptInvitationMutationMutation,
    AcceptInvitationMutationMutationVariables
  >({
    mutation: AcceptInvitationMutation,
    variables: {
      invitationId: form.value.invitationId,
      token: form.value.token,
      newSubscriptionUserInput: form.value.newSubscriptionUserInput,
    },
  })

  if (result?.data?.acceptInvitation?.invitation?.id) {
    gotoFinal()
  }

  isSubmitting.value = false
}

const SuccessMessage = {
  ahead_business: {
    title: "Welcome to AHEAD",
    subtitle:
      "Get ready to take your skills to the next level. You will receive an email with your login credentials to the AHEAD platform shortly, giving you access to a world of learning and development opportunities.",
  },
  peralta: {
    title: "Welcome to Peralta",
    subtitle:
      "You've joined the future of work! You now have access a wide range of tools to manage your team, projects, and goals. Get started by clicking the button below.",
  },
}

return { __sfc: true,props, productType, step, observer, isEmailAvailable, gotoFinal, isSubmitting, router, form, mutate, onSubmit, SuccessMessage, Step, InvitationLayout, FinalStep, CheckStep, AHEAD_THEME }
}

})